console.log('quickview loaded..');
var quickViewSubmitBtn = document.querySelector(
    'quick-add-modal.quick-add-modal .quickview-modal .product-form__submit'
);
var quickViewParentContainer = quickViewSubmitBtn.parentElement.parentElement;

console.log('QVSB from asset', quickViewSubmitBtn);

quickViewSubmitBtn.addEventListener('click', (evt) => {
    let parentEl = evt.target.closest('.relative');
    let id = parentEl.querySelector('input[name="single-pdt-id"]').value;
    let atcMsg = parentEl.querySelector('.add-to-cart-message');

    count = parentEl.querySelector('#single-pdt-quantity').value * 1 + 1;

    parentEl.querySelector('.add-to-cart-message').classList.add('button-inactive');
    parentEl.querySelector('.product-content-count').classList.remove('hide');
    parentEl.querySelector('.content-product-add').classList.remove('hide');
    parentEl.querySelector('.product-count').innerText = count;

    //atcMsg.innerText = "Added to cart";
    let span = parentEl.querySelector('.product-variants .variant-' + id + '.variant-count span');
    if (span) {
        span.innerText = count;
    }
    console.log('span', span);
    addProduct(id);
});


var quickvewAddBtn = quickViewParentContainer.querySelector('.content-product-add .product-add');
var quickvewRemoveBtn = quickViewParentContainer.querySelector('.content-product-add .product-remove');

quickvewAddBtn.addEventListener('click', (addevt) => {
    let parentEl = addevt.target.closest('.relative');
    let id = parentEl.querySelector('#single-pdt-variant').value;
    addProduct(id);

    let count = parentEl.querySelector('.product-count').innerText * 1 + 1;
    parentEl.querySelector('.product-count').innerText = count;

    let span = quickViewParentContainer.querySelector('.product-variants .variant-' + id);
    span.querySelector('.variant-count span').innerText = count;
    console.log('span', span);
});

quickvewRemoveBtn.addEventListener('click', (removeEvt) => {
    let parentEl = removeEvt.target.closest('.relative');
    console.log('parentEl', parentEl);

    let id = parentEl.querySelector('#single-pdt-variant').value;
    console.log('id', id);

    let count = parentEl.querySelector('.product-count').innerText * 1;
    console.log('count', count);

    let span = quickViewParentContainer.querySelector('.product-variants .variant-' + id);

    if(count>0){
        if (count === 1) {
            parentEl.querySelector('.content-product-add').classList.add('hide');
            parentEl.querySelector('.add-to-cart-message').classList.remove('button-inactive');
        }
        count -= 1;
    }else{
        count = 0;
    }
    let params = {
        quantity: count,
        id: id
    };

    removeProductCart(params);

    parentEl.querySelector('.product-count').innerText = count;
    span.querySelector('.variant-count span').innerText = count;
});